import 'react-native-url-polyfill/auto';
import { registerRootComponent } from 'expo';
import { ReadableStream, WritableStream, TransformStream } from 'web-streams-polyfill';
import { TextEncoder, TextDecoder } from 'text-encoding';

import { Buffer } from 'buffer';
global.Buffer = Buffer;

// Polyfills
if (typeof global.ReadableStream === 'undefined') {
    global.ReadableStream = ReadableStream;
}
if (typeof global.WritableStream === 'undefined') {
    global.WritableStream = WritableStream;
}
if (typeof global.TransformStream === 'undefined') {
    global.TransformStream = TransformStream;
}
if (typeof global.TextEncoder === 'undefined') {
    global.TextEncoder = TextEncoder;
}
if (typeof global.TextDecoder === 'undefined') {
    global.TextDecoder = TextDecoder;
}

// Navigator and Location polyfills for LiveKit environment check
if (typeof global.navigator === 'undefined') {
    global.navigator = {};
}
if (typeof global.navigator.userAgent === 'undefined') {
    global.navigator.userAgent = 'react-native';
}
if (typeof global.location === 'undefined') {
    global.location = {
        href: '',
        protocol: 'https:',
        host: '',
        hostname: '',
        pathname: '',
        search: '',
        hash: '',
        origin: ''
    };
}

// Process version polyfill
if (typeof global.process === 'undefined') {
    global.process = require('process');
}
if (typeof global.process.version === 'undefined') {
    global.process.version = 'v16.0.0';
}
if (typeof global.process.env === 'undefined') {
    global.process.env = {};
}

// b64 polyfills
if (typeof global.atob === 'undefined') {
    global.atob = (str) => Buffer.from(str, 'base64').toString('binary');
}
if (typeof global.btoa === 'undefined') {
    global.btoa = (str) => Buffer.from(str, 'binary').toString('base64');
}

// Register LiveKit/WebRTC native globals.
// IMPORTANT: This requires a native build (expo run:android / expo run:ios)
// or a custom dev client. It will NOT work in standard Expo Go.
// We wrap in try/catch so the rest of the app still launches even if
// the WebRTC native module is unavailable (e.g. inside Expo Go).
global.__LIVEKIT_AVAILABLE__ = false;
try {
    const { registerGlobals } = require('@livekit/react-native-webrtc');
    registerGlobals();
    global.__LIVEKIT_AVAILABLE__ = true;
    console.log('[LiveKit] WebRTC globals registered successfully');
} catch (e) {
    console.warn('[LiveKit] WebRTC native module not available. Live video will be disabled. Use a custom dev build (expo run:android) to enable it.', e.message);
}

import App from './App';

// registerRootComponent calls AppRegistry.registerComponent('main', () => App);
// It also ensures that whether you load the app in Expo Go or in a native build,
// the environment is set up appropriately
registerRootComponent(App);
